import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { applyAppBranding } from './helpers/applyAppBranding';

// Replace index.html's neutral title/favicon with this build's app branding.
applyAppBranding();

// A deploy replaces the hashed chunk files; a session started before it still
// references the old hashes and gets the SPA fallback (text/html) instead.
// Navigate once with a cache-busting query param — the stale index.html is
// itself CDN-cached (s-maxage), so a plain reload would refetch the same
// document with the same dead chunk hashes. The bust relies on the CDN
// including query strings in its cache key, which Cloudflare (fronting this
// deployment) does by default — revisit if the CDN changes.
window.addEventListener('vite:preloadError', (event) => {
  const url = new URL(window.location.href);
  // One attempt per document: a page that already loaded via a cache-bust and
  // still fails has a different problem. This guard needs no storage, so it
  // also bounds the retry where sessionStorage is blocked (Safari private mode).
  if (url.searchParams.has('_cb')) return;
  const RELOAD_AT_KEY = 'chunk-reload-at';
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    if (Date.now() - lastReload < 10_000) return;
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  } catch {
    // Storage blocked — the _cb guard above still bounds this to one attempt.
  }
  event.preventDefault();
  url.searchParams.set('_cb', String(Date.now()));
  window.location.replace(url.toString());
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

